import {getJson} from '@/util/ajaxUtils';

export function getFollowInfos(userId, params) {
    return getJson(`/follow/list/${userId}`, {params});
}

export function getAllFollowInfos(userId) {
    return getJson(`/follow/list/all/${userId}`);
}
